<template lang="html">
  <vs-card class="cardx ">
    <div slot="header" style="padding:10px">
      <h3>
        New trip
      </h3>
    </div>

    <div class="mb-2">
      <vs-alert :key="'e-'+index" v-for="(error,index) in errorForm" :active="true" color="danger" icon="new_releases" class="mb-2">
        <span >{{error}}</span>
      </vs-alert>
    </div>

    <div>
      <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="formSubmitted">

        <tab-content title="Dates" class="mb-5" :before-change="()=>validateStep(1)">
          <div class="wizard-card-footer clearfix mb-4" style="padding-right: 0">
            <div class="wizard-footer-right">
              <span role="button" tabindex="0">
                <button @click="nextStep(1)"  tabindex="-1" type="button" class="wizard-btn" style="background-color: rgba(var(--vs-primary), 1); border-color: rgba(var(--vs-primary), 1); color: white;">
                Next
               </button>
              </span>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full mt-5">
              <calendar v-model="dates"></calendar>
            </div>
          </div>
        </tab-content>

        <tab-content title="Route" class="mb-5" :before-change="()=>validateStep(2)">
          <div class="wizard-card-footer clearfix mb-4" style="padding-right: 0">
            <div class="wizard-footer-right">
              <span role="button" tabindex="0">
                <button @click="nextStep(2)"  tabindex="-1" type="button" class="wizard-btn" style="background-color: rgba(var(--vs-primary), 1); border-color: rgba(var(--vs-primary), 1); color: white;">
                Next
               </button>
              </span>
            </div>
          </div>
          <form @submit.prevent="" data-vv-scope="step2">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <label class="vs-input--label">Zone</label>
                <v-select
                  name="zone"
                  v-validate="'required'"
                  :class="errors.has('step2.zone') ? 'danger':''"
                  :disabled="input_disabled" @input="getRoutes"
                  v-model="form.zone_id" :options="zones"
                  :reduce="el => el.id" label="name" />
                <span v-show="errors.has('step1.zone')" class="text-danger">{{ errors.first('step2.zone') }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <label class="vs-input--label">Route</label>
                <v-select
                  name="route"
                  v-validate="'required'"
                  :class="errors.has('step2.route') ? 'danger':''"
                  @input="fetchRoute" :disabled="input_disabled||!form.zone_id"
                          v-model="form.route_id" :options="routes"
                          :reduce="el => el.id" label="name" />
                <span v-show="errors.has('step1.route')" class="text-danger">{{ errors.first('step2.route') }}</span>
              </div>

              <div class="vx-col md:w-1/2 w-full md:mt-8">
                <div class="demo-alignment">
                  <div class="flex">
                    <vs-checkbox v-model="form.is_active" :disabled="input_disabled">Enabled</vs-checkbox>
                  </div>
                </div>
              </div>

            </div>
          </form>
        </tab-content>


        <tab-content title="Stations" class="mb-5" :before-change="()=>validateStep(3)">
          <div class="wizard-card-footer clearfix mb-4" style="padding-right: 0">
            <div class="wizard-footer-right">
              <span role="button" tabindex="0">
                <button @click="nextStep(3)"  tabindex="-1" type="button" class="wizard-btn" style="background-color: rgba(var(--vs-primary), 1); border-color: rgba(var(--vs-primary), 1); color: white;">
                Next
               </button>
              </span>
            </div>
          </div>
          <form @submit.prevent="" data-vv-scope="step3">
            <vs-row class="mb-3" :key="'st-'+index" v-for="(station,index) in form.stations">
              <vs-col  vs-lg="4" vs-sm="4" vs-xs="12" style="padding:10px;">
                <div style="display: inline-flex;">{{station.name}}</div>
              </vs-col>

              <vs-col  vs-lg="3" vs-sm="3" vs-xs="12" class="pr-2">
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="station.arrival"
                  v-validate="'required'+ (index < form.stations.length && index > 0  ? (form.stations[index-1].departure && station.departure ? `|time_between:${form.stations[index-1].departure},${station.departure}`:'') : (station.departure ? `|time_lt:${station.departure}` :''))"
                  :name="'arrival'+index"
                  data-vv-as="arrival"
                  :class="errors.has('step3.arrival'+index) ? 'flatpickr-input border-danger w-full':'flatpickr-input w-full'"
                  placeholder="Arrival"
                  style="margin-right: 10px;" />
                <span><div class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to" style="">
                  <span class="span-text-validation">{{errors.first('step3.arrival'+index)}}</span></div>
                </span>
              </vs-col>
              <vs-col  vs-lg="3" vs-sm="3" vs-xs="12" class="pr-2">
                <flat-pickr :config="configdateTimePicker"
                            v-model="station.departure"
                            v-validate="'required'+(station.arrival ? `|time_gt:${station.arrival}` :'')"
                            :name="'departure'+index"
                            data-vv-as="departure"
                            :class="errors.has('step3.departure'+index) ? 'flatpickr-input border-danger w-full':'flatpickr-input  w-full'"
                            placeholder="Departure" style="margin-right: 10px;" />
                <span><div class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to" style="">
                  <span class="span-text-validation">{{errors.first('step3.departure'+index)}}</span></div>
                </span>

              </vs-col>
              <vs-col  vs-lg="2" vs-sm="2" vs-xs="12">
                <v-select :clearable="false" :disabled="input_disabled"
                          v-model="station.type"
                          :options="station_types"
                          :reduce="el => el.value" label="text"  />
              </vs-col>
            </vs-row>
          </form>
        </tab-content>

        <tab-content title="Partner" class="mb-5" :before-change="()=>validateStep(4)">

          <div class="wizard-card-footer clearfix mb-4" style="padding-right: 0">
            <div class="wizard-footer-right">
              <span role="button" tabindex="0">
                <button @click="nextStep(3)"  tabindex="-1" type="button" class="wizard-btn" style="background-color: rgba(var(--vs-primary), 1); border-color: rgba(var(--vs-primary), 1); color: white;">
                Next
               </button>
              </span>
            </div>
          </div>

          <form @submit.prevent="" data-vv-scope="step4">
            <div class="vx-row">
              <div v-if="!this.partner_namespace" class="vx-col md:w-1/2 w-full mb-4">
                <label class="vs-input--label">Partner</label>
                <v-select @input="fetchPartnerData" :disabled="input_disabled||!form.zone_id"
                          v-model="form.partner_id"
                          name="partner"
                          v-validate="'required'"
                          :class="errors.has('step4.partner') ? 'danger':''"
                          :options="partners.partners"
                          :reduce="el => el.id" label="name"  />
              </div>

              <div class="vx-col md:w-1/2 w-full mb-4">
                <label class="vs-input--label">Driver</label>
                <v-select :disabled="input_disabled||!form.partner_id"
                          v-model="form.driver_id"
                          name="driver"
                          v-validate="'required'"
                          :class="errors.has('step4.driver') ? 'danger':''"
                          :options="drivers"
                          :reduce="el => el.id"
                          :get-option-label="(option)=>{ return `${option.firstname} ${option.lastname}`}"
                          label="firstname"  />
              </div>

              <div class="vx-col md:w-1/2 w-full mb-4">
                <label class="vs-input--label">Vehicle</label>
                <v-select @input="setDefaultSeats" :disabled="input_disabled||!form.partner_id"
                          v-model="form.vehicle_id"
                          name="vehicle"
                          v-validate="'required'"
                          :class="errors.has('step4.vehicle') ? 'danger':''"
                          :options="vehicleList"
                          :reduce="el => el.id" label="nicename"  />
              </div>

              <div class="vx-col md:w-1/2 w-full mb-4">
                <vs-input type="text" label="Trip code"
                          name="code"
                          v-validate="''"
                          :danger="errors.has('step4.code')"
                          :danger-text="errors.has('step4.code')? errors.first('step4.code'):null"
                          v-model="form.code" :disabled="input_disabled" class="w-full" />
              </div>

            </div>
          </form>
        </tab-content>

        <tab-content title="Price" class="mb-5" :before-change="()=>validateStep(5)">


          <form @submit.prevent="" data-vv-scope="step5">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input type="number" label="Seats"
                          name="seats"
                          v-validate="'required|min_value:0|'+ ('max_value:'+maxSeats)"
                          :danger="errors.has('step5.seats')"
                          :danger-text="errors.has('step5.seats')? errors.first('step5.seats'):null"
                          v-model="form.seats"
                          :disabled="input_disabled" class="w-full mt-5" />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <vs-input type="number" label="Price"
                          name="price"
                          v-validate="'required|min_value:0'"
                          :danger="errors.has('step5.price')"
                          :danger-text="errors.has('step5.price')? errors.first('step5.price'):null"
                          v-model="form.price" :disabled="input_disabled" class="w-full mt-5" />
              </div>
            </div>
          </form>
        </tab-content>
      </form-wizard>

    </div>
  </vs-card>
</template>


<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import Datepicker from 'vuejs-datepicker';
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Calendar from './calendar';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import {STATION_TYPE} from "../../constants/routes";


  export default {
    name: 'TripWizard',
    components: {
      FormWizard,
      TabContent,
      Datepicker,
      Calendar,
      flatPickr
    },
    data (){
      return {
        search: '',
        form :{
          zone_id : null,
          route_id : null,
          stations: [],
          partner_id : null,
          driver_id :  null,
          vehicle_id : null,
          seats : null,
          price : 0
        },
        dates : [],

        routes : [],
        drivers : [],
        vehicles : [],
        input_disabled : false,
        station_types : STATION_TYPE,
        configdateTimePicker: {
          enableTime: true,
          enableSeconds: true,
          noCalendar: true,
          time_24hr: true
        },

        maxSeats : 0,
        errorForm : []
      }
    },
    computed : {
      ...mapState(['partner_namespace']),
      ...mapGetters('users',['userCan']),
      ...mapState('partners',['partners']),
      ...mapGetters('zones',['zones']),
      vehicleList(){
        return this.vehicles.map(item =>({
          ...item,
          nicename: `${item.eco_number ? `${item.plate} (${item.eco_number})`: item.plate} - ${item.seats} seats`
        }))
      }
    },
    created(){
      if(this.partner_namespace){
        this.form.partner_id = this.partner_namespace;
        if(this.zones.length === 1){
          this.form.zone_id = this.zones[0].id;
          this.getRoutes();
        }
        this.fetchPartnerData();
      }else{
        this.fetchPartners({limit: 500});
      }

      if(this.$route.query.trip_id){
        this.setInitialData();
      }
    },
    methods: {
      ...mapActions('routes',['fetchRoutes','getRoute']),
      ...mapActions('vehicles',['fetchVehicles','getVehicle']),
      ...mapActions('drivers',['fetchDrivers','getDriver']),
      ...mapActions('trips',['storeTrip','getTrip']),
      ...mapActions('partners',['fetchPartners']),
      async setInitialData(){
        this.getTrip({id: this.$route.query.trip_id})
          .then(data=>{
            this.form.zone_id = data.route.zone.id;
            this.form.route_id = data.route.id;
            this.form.is_active = data.is_active;
            this.form.stations = data.stations.map(item => ({
              station_id: item.station.id,
              order : item.order,
              type : item.type,
              arrival : item.arrival,
              departure : item.departure,
              name : item.station.name
            }));
            this.form.driver_id = data.driver.id;
            this.form.vehicle_id = data.vehicle.id;
            this.form.seats = data.seats;
            this.form.price = data.price;
            this.form.partner_id = data.partner.id;
            if(data.code){
              this.form.code = data.code;
            }

            this.getRoutes(false);
            this.fetchPartnerData(false)

          })
          .catch(error =>{
            console.log(error)
          });
      },
      getRoutes(resetRoute = true){
        this.input_disabled = true;
        if(resetRoute){
          this.form.route_id = null;
        }
        this.fetchRoutes({zone_id: this.form.zone_id, limit: 500})
          .then(data=>{
            this.input_disabled = false;
            this.routes = data.routes;
          })
          .catch(error =>{

          });
      },
      fetchRoute(){
        this.getRoute({id: this.form.route_id})
        .then(data=>{
          this.form.zone_id = data.zone.id;
          this.form.stations = data.stations.map(item => ({
            station_id: item.station.id,
            order : item.order,
            type : item.type,
            arrival : null,
            departure : null,
            name : item.station.name
          }));

        })
        .catch(error =>{

        })
      },
      fetchPartnerData(reset = true){
        if(reset){
          this.form.driver_id = null;
          this.form.vehicle_id = null;
        }

        this.fetchDrivers({page:1, limit: 1000, partner_id: this.form.partner_id})
        .then(data=>{
          this.drivers = data.drivers;
        })
        .catch(error =>{

        });

        this.fetchVehicles({page:1, limit: 100000, partner_id: this.form.partner_id})
          .then(data=>{
            this.vehicles = data.vehicles;
            if(this.form.vehicle_id){
              let vehicle = this.vehicles.find(item => item.id === this.form.vehicle_id);
              if(vehicle){
                this.maxSeats = vehicle.seats;
              }
            }
          })
          .catch(error =>{

          });
      },
      setDefaultSeats(){
        let vehicle = this.vehicles.find(item => item.id === this.form.vehicle_id);
        if(vehicle){
          this.form.seats = vehicle.seats;
          this.maxSeats = vehicle.seats;
        }

      },
      async nextStep(step){
        this.$refs.wizard.nextTab();
      },
      async validateStep(step){
        if(step === 1){
          if(this.dates.length === 0){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You have to select at least one date',
            });
            return false;
          }
          return true;
        }
        return await this.$validator.validateAll('step'+step);

      },
      async formSubmitted(){

        if(!this.userCan('trips.create')){
          this.$vs.notify({
            color: 'danger',
            title: `Error`,
            text: 'You need permission to perform this action',
          });
          return;
        }

        if(this.onSubmit === true){
          return;
        }
        this.$vs.loading({
          type:'point',
        });
        this.onSubmit = true;
        this.input_disabled = true;

        let form = _.cloneDeep(this.form);
        delete form.zone_id;
        form.stations = form.stations.map(item => ({
          station_id: item.station_id,
          order : item.order,
          type : item.type,
          arrival : item.arrival,
          departure : item.departure,
        }))

        let success = true;
        let msg = '';
        this.errorForm = [];

        for(let item of this.dates){
          form.date = item;
          let response;
          try{
            response = await this.storeTrip(form);
          }catch (e) {
            response = e;
          }
          if(response){
            if(response.status === 201){
              success = true;
              msg = 'Trips successfully created';
            }else if(response.status === 409){
              success = false;
              msg = 'Oops, something went wrong!';
              for(let key in response.data.errors){
                if(Array.isArray(response.data.errors[key])){
                  this.errorForm.push(key+': '+ response.data.errors[key][0]);
                }
              }
            }else if(response.status >= 500){
              success = false;
              msg = 'Oops, something went wrong!'
            }else{
              success = false;
              msg = 'Oops, something went wrong!'
            }
          }

          if(success === false){
            break;
          }
        }
        this.onSubmit = false;
        this.$vs.notify({
          color: success ?  'success':'error',
          title: success ?'Success':'Error',
          text: msg,
        });
        this.$vs.loading.close();
        if(success === true){
          if(this.partner_namespace){
            this.$router.push({ name:'partner.trips'});
          }else{
            this.$router.push({ name: 'trips List'});
          }

        }
      },
    },
  }
</script>
